<template>
	<el-dialog title="费用详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">费用信息</p> -->
			<div class="flex">
				<div class="rpt_tit">
					<p class="platTitle">费用信息</p>
				</div>
				<div class="editimg fontSize18" style="text-decoration: underline;">
					<div v-if="exoedit" class="flex">
						<div class="mr-10" @click="exoeditsave">保存</div>
						<div class="mr-10" @click="exoeditChange(false)">取消</div>
					</div>
					<div class="mr-10" @click="exoeditChange(true)" v-if="exoChkStatus!=='1'&&!exoedit">编辑</div>
					<div v-if="exoChkStatus=='0'" @click="handleAudits(exoId)">审核
					</div>
				</div>
			</div>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>发起人</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="exoAdvanceUserid" placeholder="请选择" @change="userListChange" disabled>
								<el-option v-for="(item, index) in userList" :key="item.userId" :label="item.name"
									:value="item.userId">
									<span style="float: left">{{ item.name }}</span>
									<span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;"
										v-if="item.type=='0'">
										驾驶员
									</span>
									<span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;"
										v-if="item.type=='1'">
										押运员
									</span>
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>关联车辆</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="exoVehicleId" filterable placeholder="请选择" @change="vehicleHeadChange"
								disabled>
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehHeadNo"
									:value="item.vehicleId">
									<span style="float: left">{{ item.vehHeadNo }}</span>
									<span style="
															          float: right;
															          color: var(--el-text-color-secondary);
															          font-size: 13px;
															        ">
										{{ item.vehAffOrgName }}
									</span>
								</el-option>
							</el-select>
						</div>
					</div>
					<!-- <div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>关联运单号</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="orgType" placeholder="请选择机构类型">
								<el-option label="平台机构" value="0" />
								<el-option label="物流公司" value="1" />
								<el-option label="LNG运输公司" value="2" />
							</el-select>
						</div>
					</div> -->
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>关联运单号</span>
						</div>
						<el-input v-model="exoOdrId" class="platItemRigth" placeholder="请输入" disabled />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>费用类型</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="loreType" placeholder="请选择" @change="MExoiChange" disabled>
								<el-option v-for="(item, index) in loreTypeList" :key="item.typeId"
									:label="item.typeName" :value="item.typeId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>费用子项</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="loreSubtype" placeholder="请选择" @change="SExoiChange" disabled>
								<el-option v-for="(item, index) in loreSubTypeList" :key="item.typeSubId"
									:label="item.typeSubName" :value="item.typeSubId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>支付类型</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="paymentTypeValue" placeholder="请选择支付类型" disabled>
								<el-option label="公司定点费用" value="0" />
								<el-option label="垫付费用" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>数量</span>
						</div>
						<el-input v-model="exoiCount" class="platItemRigth" placeholder="请输入"
							:disabled="exoeditisReadOnly" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">

							<span class="input-fail">*</span>
							<span>金额</span>
						</div>
						<el-input v-model="exoiSumPrice" class="platItemRigth" placeholder="请输入"
							:disabled="exoeditisReadOnly" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>发生时间</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="exoiPayTime" type="datetime" :clearable="false"
								placeholder="请选择计划装货时间" @change="getexoiPayTime" disabled>
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>发生地址</span>
						</div>
						<el-input v-model="exoiPayAddr" class="platItemRigth" placeholder="请输入" disabled />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>费用说明</span>
						</div>
						<el-input v-model="exoiDescribe" class="platItemRigth" placeholder="请输入" disabled />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>表显里程</span>
						</div>
						<el-input v-model="exoiOdometer" class="platItemRigth" placeholder="请输入" disabled />
					</div>

				</div>
			</div>
			<p class="platTitle">费用附件</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 platItem flex" style="align-items: flex-start">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>附件</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth">
							<img v-if="exoiReceiptUrl==''" src="@/assets/images/upload_img.png" alt="" srcset="" />
							<img v-else :src="exoiReceiptUrl" alt="" srcset="" v-viewer />
						</div>

					</div>

					<div class="w50 platItem flex" style="align-items: flex-start">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>车里程表照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth">
							<img v-if="exoiOdoUrl==''" src="@/assets/images/upload_img.png" alt="" srcset="" />
							<img v-else :src="exoiOdoUrl" alt="" srcset="" v-viewer />
						</div>

					</div>
				</div>
			</div>

			<el-dialog title="审核" v-model="isAudit" width="30%" center>
				<div class="mar-bot-20"><span style="color: red">*</span>审核意见</div>
				<div style="width: 100%; height: 80px">
					<el-input type="textarea" v-model="auditsRemark" placeholder="请输入审核意见"></el-input>
				</div>
				<div class="btn_warp">
					<div class="btn-outline1" @click="Auditssubmit(1)">不通过</div>
					<div class="btn-outline2" @click="Auditssubmit(0)">通过</div>
				</div>
			</el-dialog>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Add",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {
					getUserList(); //获取费用发起人
					getVehicleList(); //获取承运车辆
				});
			});
			const data = reactive({
				isDetail: false,
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				userList: [], //发起人列表
				vehHeadList: [], //关联车辆
				bindVehId: "",
				bindVehNo: "",
				bindVehicel: "",
				isAudit: false,
				auditsexoId: "",
				auditsRemark: "",
				exoedit: false,
				exoeditisReadOnly: true,

				typeIndex: null,
				typeSubIndex: null,
				loreSubTypeList: [],
				loreTypeList: [{
						typeName: "高速费",
						typeId: '0',
						loreSubTypeList: [{
							typeSubName: "高速费",
							typeSubId: '0'
						}]
					},
					{
						typeName: "路桥费",
						typeId: '1',
						loreSubTypeList: [{
							typeSubName: "路桥费",
							typeSubId: '0'
						}]
					},
					{
						typeName: "燃料费",
						typeId: '2',
						loreSubTypeList: [{
							typeSubName: "加气费",
							typeSubId: '0'
						}]
					},
					{
						typeName: "维修费",
						typeId: '3',
						loreSubTypeList: [{
							typeSubName: "维修费",
							typeSubId: '0'
						}]
					},
					{
						typeName: "停车费",
						typeId: '4',
						loreSubTypeList: [{
							typeSubName: "停车费",
							typeSubId: '0'
						}]
					}
				],

				//垫付类型
				paymentTypeIndex: "",
				paymentTypeName: "",
				paymentTypeValue: "",
				paymentTypeArr: [{
					value: '0',
					name: '公司定点费用'
				}, {
					value: '1',
					name: '垫付费用'
				}],

				pageType: "",
				userNickname: "",
				userId: "",
				loreId: "", //费用单ID
				loreLorid: "", //运输订单
				loreType: "", //费用类型：0高速费1路桥费2燃料费3维修费4停车费5保险分摊费6安全费7折旧费8轮胎租赁费9转包运费支出10过磅费11固定成本费12检测费50其它费用
				loreSubtype: "", //子费用类型
				loreName: "", //费用名称
				loreSubName: "", //子费用名称
				loreAdvanceUserid: null, //垫付人ID
				lorePrice: 0, //单价
				loreCount: null, //数量 加油量升 加气量千克
				loreGoods: "", //货品名称
				loreSumPrice: "", //总费用
				lorePayTime: "", //支付时间
				lorePayAddr: "", //支付地址
				loreDescribe: "", //费用说明
				loreHaveInvoice: "0", //有无发票 0无 1有
				loreReceiptUrl: "", //单据附件 
				loreOdometer: "", //表显里程数
				loreOdoUrl: "", //表显里程照片

				exoId: null, //费用单ID
				exoChkStatus: null, //审核状态
				exoOdrType: "0", //运单类型：0LNG运单，1物流运单
				exoOdrId: "", //运输订单ID，外建，关联LNG运输订单表和物流运输订单表
				exoVehicleId: null, //运力ID
				exoVehId: null, //车辆ID
				exoVehNo: "", //运力车辆名称
				exoAdvanceType: "0", //垫付类型：0定点费用，1垫付费用
				exoAdvanceUserid: null, //垫付人ID
				exoName: "", //费用单名称：
				exoType: "", //费用类型：0高速费1路桥费2燃料费3维修费
				exoDescribe: "", //费用单说明
				exoiSubtype: "", //子费用类型：
				exoiName: "", //费用名称
				exoiPrice: 0, //单价
				exoiCount: null, //数量：件数，加油量（升），加气量（千克）
				exoiGoods: "", //货品名称
				exoiSumPrice: "", //费用总金额
				exoiPayTime: "", //支付时间
				exoiPayAddr: "", //支付地点
				exoiDescribe: "", //费用说明
				exoiHaveInvoice: "0", //有无发票：0无发票，1有发票
				exoiReceiptUrl: "", //单据附件：图片，PDF
				exoiOdometer: "", //里程表数
				exoiOdoUrl: "" //里程表照片
			});
			//重置数据
			const init = async (id) => {
				data.exoedit = false;
				data.exoeditisReadOnly = true;
				data.isDetail = true;
				data.exoId = id;

				let params = {
					exoId: data.exoId,
				};
				const res = await proxy.$http.get(apiObj.expensesOrderEdit, params);
				if (res) {
					data.exoOdrType = res.expensesOrder.exoOdrType; //运单类型：0LNG运单，1物流运单
					data.exoOdrId = res.expensesOrder.exoOdrId; //运输订单ID，外建，关联LNG运输订单表和物流运输订单表
					data.exoChkStatus = res.expensesOrder.exoChkStatus; //审核状态
					data.exoVehicleId = res.expensesOrder.exoVehicleId; //运力ID
					data.exoVehId = res.expensesOrder.exoVehId; //车辆ID
					data.exoVehNo = res.expensesOrder.vehNo; //车牌号
					data.exoAdvanceType = res.expensesOrder.exoAdvanceType; //垫付类型：0定点费用，1垫付费用
					data.exoAdvanceUserid = res.expensesOrder.exoAdvanceUserid; //垫付人ID
					data.exoName = res.expensesOrder.exoName; //费用单名称：
					data.exoType = res.expensesOrder.exoType; //费用类型：0高速费1路桥费2燃料费3维修费
					data.exoDescribe = res.expensesOrder.exoDescribe; //费用单说明
					data.exoiSubtype = res.expensesOrder.itemList[0].exoiSubtype; //子费用类型：
					data.exoiName = res.expensesOrder.itemList[0].exoiName; //费用名称
					data.exoiPrice = res.expensesOrder.itemList[0].exoiPrice; //单价
					data.exoiCount = res.expensesOrder.itemList[0].exoiCount; //数量：件数，加油量（升），加气量（千克）
					data.exoiGoods = res.expensesOrder.itemList[0].exoiGoods; //货品名称
					data.exoiSumPrice = res.expensesOrder.itemList[0].exoiSumPrice; //费用总金额
					data.exoiPayTime = res.expensesOrder.itemList[0].exoiPayTime; //支付时间
					data.exoiPayAddr = res.expensesOrder.itemList[0].exoiPayAddr; //支付地点
					data.exoiDescribe = res.expensesOrder.itemList[0].exoiDescribe; //费用说明
					data.exoiHaveInvoice = res.expensesOrder.itemList[0].exoiHaveInvoice; //有无发票：0无发票，1有发票
					data.exoiReceiptUrl = res.expensesOrder.itemList[0].exoiReceiptUrl; //单据附件：图片，PDF
					data.exoiOdometer = res.expensesOrder.itemList[0].exoiOdometer; //里程表数
					data.exoiOdoUrl = res.expensesOrder.itemList[0].exoiOdoUrl; //里程表照片

					data.loreName = res.expensesOrder.exoName;
					data.loreType = res.expensesOrder.exoType;
					data.typeIndex = res.expensesOrder.exoType;
					data.typeSubIndex = res.expensesOrder.itemList[0].exoiSubtype;
					data.loreSubTypeList = data.loreTypeList[data.typeIndex]
						.loreSubTypeList;
					data.loreSubName = data.loreSubTypeList[data.typeSubIndex].typeSubName;
					data.loreSubtype = data.loreSubTypeList[data.typeSubIndex].typeSubId;

					data.paymentTypeIndex = res.expensesOrder.exoAdvanceType;
					data.paymentTypeName = data.paymentTypeArr[data.paymentTypeIndex].name;
					data.paymentTypeValue = data.paymentTypeArr[data.paymentTypeIndex].value;
				}
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};
			const exoeditsave = async () => {

				if (data.exoAdvanceUserid === "" || data.exoAdvanceUserid == null) {
					proxy.$message.error("请选择发起人");
					return;
				}

				if (data.exoVehicleId === "" || data.exoVehicleId == null) {
					proxy.$message.error("请选择关联车辆");
					return;
				}

				if (data.paymentTypeValue === "" || data.paymentTypeValue == null) {
					proxy.$message.error("请选择支持类型");
					return;
				}

				if (data.loreType === "" || data.loreType == null) {
					proxy.$message.error("请选择费用类型");
					return;
				}
				if (data.loreSubtype === "" || data.loreSubtype == null) {
					proxy.$message.error("请选择子费用类型");
					return;
				}
				if (data.exoiCount === "" || data.exoiCount == null) {
					proxy.$message.error("请填写数量");
					return;
				}
				if (data.exoiSumPrice === "" || data.exoiSumPrice == null) {
					proxy.$message.error("请填写费用金额");
					return;
				}
				if (data.exoiPayTime === '' || data.exoiPayTime == null) {
					proxy.$message.error("请选择费用发生时间");
					return;
				}
				if (data.exoiPayAddr === "" || data.exoiPayAddr == null) {
					proxy.$message.error("请填写费用地址");
					return;
				}

				let params = {
					exoId: data.exoId,
					exoOdrType: data.exoOdrType, //运单类型：0LNG运单，1物流运单
					exoOdrId: data.exoOdrId, //运输订单ID，外建，关联LNG运输订单表和物流运输订单表
					exoVehicleId: data.exoVehicleId, //运力ID
					exoVehId: data.exoVehId, //车辆ID
					exoAdvanceType: data.paymentTypeValue, //垫付类型：0定点费用，1垫付费用
					exoAdvanceUserid: data.exoAdvanceUserid, //垫付人ID
					exoName: data.loreName, //费用单名称：
					exoType: data.loreType, //费用类型：0高速费1路桥费2燃料费3维修费
					exoDescribe: data.exoDescribe, //费用单说明
					itemList: [{
						exoiSubtype: data.loreSubtype, //子费用类型：
						exoiName: data.loreSubName, //费用名称
						exoiPrice: data.exoiPrice, //单价
						exoiCount: data.exoiCount, //数量：件数，加油量（升），加气量（千克）
						exoiGoods: data.loreSubName, //货品名称
						exoiSumPrice: data.exoiSumPrice, //费用总金额
						exoiPayTime: data.exoiPayTime, //支付时间
						exoiPayAddr: data.exoiPayAddr, //支付地点
						exoiDescribe: data.exoiDescribe, //费用说明
						exoiHaveInvoice: data.exoiHaveInvoice, //有无发票：0无发票，1有发票
						exoiReceiptUrl: data.exoiReceiptUrl, //单据附件：图片，PDF
						exoiOdometer: data.exoiOdometer, //里程表数
						exoiOdoUrl: data.exoiOdoUrl //里程表照片
					}],

				};

				const r = await proxy.$http.post(apiObj.expensesOrderUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.exoId);
					//data.isDetail = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			const getexoiPayTime = (ev) => {
				data.exoiPayTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.exoiPayTime);
			};


			//上传图片
			const handleAddUploadChange = (file) => {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					proxy.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (data.exoiReceiptUrl.indexOf("https://") !== -1) {
						removeImgUrl(data.exoiReceiptUrl);
					}
					upLoadBase64uploadToOSS(imageUrl, "exoiReceiptUrl");
					//data.exoiReceiptUrl = imageUrl;
				});
			};

			//上传图片
			const upLoadBase64uploadToOSS = async (imageUrl, type) => {
				await proxy.$http.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						data[type] = res;
					});
			};

			//删除图片
			const removeImgUrl = async (imageUrl) => {
				await proxy.$http.post("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			};

			//选择发起人
			const userListChange = (value) => {
				console.log(value);
				const selectedItem = data.userList.find(item => item.userId === value);
				if (selectedItem) {
					getUserVehicleList(selectedItem.userId);
				}
			}

			//选择主费用
			const MExoiChange = (value) => {
				console.log(value);
				const selectedItem = data.loreTypeList.find(item => item.typeId === value);
				if (selectedItem) {
					data.loreName = selectedItem.typeName;
					data.loreType = selectedItem.typeId;
					data.loreSubTypeList = selectedItem.loreSubTypeList;
					data.loreSubName = "";
					data.loreSubtype = "";
				} else {
					data.loreSubTypeList = [];
					data.loreSubName = "";
					data.loreSubtype = "";
				}
			}

			//选择费用子项
			const SExoiChange = (value) => {
				console.log(value);
				const selectedItem = data.loreSubTypeList.find(item => item.typeSubId === value);
				if (selectedItem) {
					data.loreSubName = selectedItem.typeSubName;
					data.loreSubtype = selectedItem.typeSubId;
				}
			}

			const vehicleHeadChange = (value) => {
				const selectedItem = data.vehHeadList.find(item => item.vehicleId === value);
				if (selectedItem) {
					data.exoVehicleId = selectedItem.vehicleId;
					data.exoVehId = selectedItem.vehicleHeadId;
				}
			}

			//获取费用发起人绑定车辆
			const getUserVehicleList = async (userId) => {
				let params = {
					driverId: userId
				};
				const r = await proxy.$http.get(apiObj.expensesOrderUserVehList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					if (r.code == 1) {
						data.bindVehId = r.lorVehHeadId; //车头ID
						data.bindVehNo = r.lorVehHeadNo; //车头车牌
						data.bindVehicel = r.lorVehicleId; //运力车辆ID
					} else {
						if (r.mVehicel !== null && r.mVehicel !== undefined && r.mVehicel != "") {
							//主驾
							data.bindVehId = r.mVehId; //车头ID
							data.bindVehNo = r.mVehNo; //车头车牌
							data.bindVehicel = r.mVehicel; //运力车辆ID
						} else if (r.sVehicel !== null && r.sVehicel !== undefined && r.sVehicel !=
							"") {
							//副驾
							data.bindVehId = r.sVehId; //车头ID
							data.bindVehNo = r.sVehNo; //车头车牌
							data.bindVehicel = r.sVehicel; //运力车辆ID
						} else if (r.yVehicel !== null && r.yVehicel !== undefined && r.yVehicel !=
							"") {
							//押运员
							data.bindVehId = r.yVehId; //车头ID
							data.bindVehNo = r.yVehNo; //车头车牌
							data.bindVehicel = r.yVehicel; //运力车辆ID
						}
					}


					data.exoVehicleId = data.bindVehicel;
					data.exoVehId = data.bindVehId;
				}
			};

			//获取费用发起人
			const getUserList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderUserList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.userList = r.data;
				}
			};

			//获取运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			const exoeditChange = (value) => {
				data.exoedit = value;
				data.exoeditisReadOnly = !value;

			};

			const handleAudits = (exoId) => {
				data.isAudit = true;
				data.auditsexoId = exoId;
				data.auditsRemark = "";
			};

			//审核
			const Auditssubmit = async (status) => {
				if (status == 1 && data.auditsRemark == "") {
					proxy.$message.error("请输入审核原因");
					return;
				}

				let params = {
					exoId: data.auditsexoId,
					operate: status, //操作类型：0通过，1不通过
					remark: data.auditsRemark
				};

				const r = await proxy.$http.postFormData(apiObj.expensesOrderExamine, params);
				if (r.respCode == 0 || r.respCode == "0000") {
					proxy.$message.success(r.msg || r.respMsg);
					data.isAudit = false;
					getData();
					init(data.exoId);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				exoeditsave,
				uniqueArr,
				handleAddUploadChange,
				MExoiChange,
				SExoiChange,
				userListChange,
				vehicleHeadChange,
				getexoiPayTime,
				exoeditChange,
				handleAudits,
				Auditssubmit
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 80px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 150px;
		height: 150px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 0px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}
</style>